import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    width: 90,
    height: 90,
    transition: 'filter 0.2s',
  },
  avatarEditable: {
    cursor: 'pointer',
    '&:hover': {
      filter: 'brightness(0.8)'
    }
  },
  overlayIcon: {
    position: 'absolute',
    color: theme.palette.white_100.main,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50%',
    padding: 6,
    pointerEvents: 'none'
  },
  hiddenInput: {
    display: 'none'
  },
  editorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  sliderContainer: {
    width: '80%',
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  dialogTitle: {
    color: theme.palette.blue_300.main
  }
}))
